<!--
 * @Descripttion: 
 * @Author: lijingjing56
 * @Date: 2024-08-09 13:59:22
 * @LastEditors: lijingjing56
 * @LastEditTime: 2025-01-20 09:54:47
-->
<template>
    <div class="container">
        <carouselBanner/>
        <service-section title="提供多场景数智服务" :mess="'一体化营销解决方案，灵活满足多种营销目标'" :data-list="serviceData"/>
        <advantages></advantages>
        <productExcellentCase :text="'成功案例'" :excellent-data="excellentData" />
        <joinList title="开放的数智生态"  :data-list="joinData"></joinList>
        <learnMaterials></learnMaterials>
    </div>
</template>
<script>
import joinList from "../../components/joinList.vue";
import learnMaterials from "./learnMaterials.vue";
import advantages from "./advantages.vue";
import serviceSection from "./serviceSection.vue";
import carouselBanner from '../../components/carouselBanner.vue';
import productExcellentCase from "../../components/productExcellentCase.vue";
export default {
  name: "home",
  components: {
    serviceSection,
    productExcellentCase,
    carouselBanner,
    advantages,
    joinList,
    learnMaterials
  },
  data() {
    return {
      link:'',
      serviceData:[
        {
          tabName:'经营增长',
          tabMess:'数据洞察与分析，制定个性化运营策略',
          img:'//img10.360buyimg.com/img/jfs/t1/254084/9/12768/44467/678dac26F467b9e5c/25ffd0d1a1441a76.png',
          child:[{
              name: "京东商智",
              link: 'https://sz.jd.com/sz/view/index/login.html?ReturnUrl=https%3A%2F%2Fsz.jd.com%2F'
            },{
              name: "数坊",
              link: 'https://4a.jd.com/datamill/common/goal.html'
            },{
              name: "京东消息类产品",
              link: 'https://jzt.jd.com/messageMarketing/index.html#/home'
            },
          ]
        },
        {
          tabName:'用户增长',
          tabMess:'全域视角，用户全生命周期精细运营',
          img:'//img10.360buyimg.com/img/jfs/t1/264551/15/13937/65532/678dac27Ffd9152fc/54b5cd6e54e20255.png',
          child:[
            {
            name: "营销云-天链",
            link: 'https://cdp.jdx.com/ca/growth-discovery'
            },
            {
            name: "营销云-会员通",
            link: 'https://cdp.jdx.com/ca/growth-discovery'
            }
          ]
        },
        {
          tabName:'营销提效',
          tabMess:'营销云乘风计划提升站外引流和站内转化效率',
          img:'//img10.360buyimg.com/img/jfs/t1/265332/25/13858/62710/678dac27F8a9ece96/585775d87f2a0514.png',
          child:[
            {
              name: "营销云-全域监测",
              link: 'https://jmctracking.jd.com/login'
            },{
            name: "营销云-RTA智能营销",
            link: 'https://rta.jdx.com/rta/brief-list'
            },{
              name: "营销云-内容营销",
              link: 'https://cdp.jdx.com/ca/growth-discovery',
            }
          ]
        },
        {
          tabName:'新品创新',
          tabMess:'全链路赋能新品创新，缩短新品到爆品的路径',
          img:'//img10.360buyimg.com/img/jfs/t1/264831/2/13945/67816/678dac27F8cd12bb0/6d123beec815f625.png',
          child:[
            {
            name: "京洞察 | 新品孵化中心",
            link: 'https://survey.jd.com/'
            }
          ]
        },
      ],
      joinData:[
      {
          name: "渠道伙伴",
          source:'//img10.360buyimg.com/img/jfs/t1/175304/4/52735/8079/673d8f4fF81726d7b/5ffa2e4b08d926b7.png',
          describe:
            "具备京东数智产品推广、咨询和销售能力，与京东共同拓展市场，推动更多品牌使用京东数智产品及服务。"
          },
        {
          name: "服务伙伴",
          source:'//img10.360buyimg.com/img/jfs/t1/175304/4/52735/8079/673d8f4fF81726d7b/5ffa2e4b08d926b7.png',
          describe:
            "依托京东数智产品，为品牌提供数智产品场景应用及解决方案等专业数智服务，助力品牌在全域多维度业务增长。"
          },
          {
          name: "ISV伙伴",
          source:'//img10.360buyimg.com/img/jfs/t1/175304/4/52735/8079/673d8f4fF81726d7b/5ffa2e4b08d926b7.png',
          describe:
            "具备自主产品、技术研发能力，与京东共建更智能便捷的数智工具，为品牌提供更高效的数智产品或解决方案，拓展数智收入。"
          }
      ],
      excellentData: [
            {
              img: '//img10.360buyimg.com/img/jfs/t1/232209/15/34249/97005/6760f580F1da1bdf2/13299362f71a75b0.png',
              title: '惠普：数坊将购模型，锁定增量人群',
              contentTitle: '品牌诉求:',
              contentMess:'锁定增量人群并进行精准推送',
              CTitle:'解决方案：',
              CArray:['1）长期用户挖掘：Datalab搭建聚类模型，构建家庭用户池；','2）模型搭建：针对大促用户，训练将购模型；','3）高潜锁定触达：联动家庭用户池和将购模型，预测用户下单行为，生成高质量潜客，进行大促触达。'],
              footer: [
                {
                  key: '产品平均成交价',
                  value: '86%'
                },
                {
                  key: 'ROI',
                  value: '13%'
                }
              ]
            },
            {
              img: '//img10.360buyimg.com/img/jfs/t1/250289/27/32340/169761/6760f59eF39f65b04/e360b8a4786f0fec.png',
              title: '阳狮×美素佳儿：全链路营销共建，助力荷美新品打爆',
              contentTitle: '品牌诉求:',
              contentMess:'为新品找到机会人群',
              CTitle:'解决方案：',
              CArray:['1）结合京洞察新品上市测试和数坊人群洞察，模拟TA反馈，找准机会人群；','2）内容营销站外种草，京准通站内承接人群再营销；','3）共建货品监测指标，及时修正投放策略。'],
              footer: [
                {
                  key: 'CTR',
                  value: '2X%'
                },
                {
                  key: '品类老客占比',
                  value: '5X%'
                }
              ]
            },
            {
              img: '//img10.360buyimg.com/img/jfs/t1/233332/40/35259/171947/6760f5b5Fb9e833d0/f41ad9ec619d91f6.png',
              title: '蒙牛纯甄京东晚8音乐会数字营销',
              contentTitle: '品牌诉求:',
              contentMess:'品牌、平台营销共创，促进品效合一',
              CTitle:'解决方案：',
              CArray:['1）寻心智热点：商智锁定TA内容偏好及需求点；','2）内容深融合：基于洞察，针对性布置晚会；','3）全链路营销闭环：营销云打通媒体数据与京东数据，在京东实现人群精细分层与再营销。'],
              footer: [
                {
                  key: '新增用户',
                  value: '122%'
                },
                {
                  key: '观众喜爱度',
                  value: '95%'
                }
              ]
            }
          ]
    };
  },
  mounted(){
    this.link = `${window.location.origin}/cloud/about/us`
  }
};
</script>